import { useSearchParams } from 'react-router';

type UseEntityModalStateProps<T extends string> = {
  defaultView: T;
};

export const useEntityModalState = <T extends string>({ defaultView }: UseEntityModalStateProps<T>) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedId = searchParams.get('id');
  const modalView = (searchParams.get('view') as T) || defaultView;

  const changeModalView = (view: T) => {
    if (selectedId) {
      searchParams.set('view', view);
      searchParams.set('id', selectedId);
      setSearchParams(searchParams);
    }
  };

  const changeSelectedItem = (id: string | null) => {
    if (id) {
      searchParams.set('id', id);
      searchParams.set('view', modalView);
      setSearchParams(searchParams);
    }
  };

  const resetSearchParams = () => {
    searchParams.delete('id');
    searchParams.delete('view');
    setSearchParams(searchParams);
  };

  return {
    selectedId,
    modalView,
    mutations: {
      changeModalView,
      changeSelectedItem,
      resetSearchParams,
    },
  };
};
